import React from 'react'
import { ReactComponent as BlotterIcon } from '../assets/blotter.svg'
import { ReactComponent as BlotterSelectIcon } from '../assets/blotter_select.svg'
import { ReactComponent as StaticsIcon } from '../assets/statics.svg'
import { ReactComponent as StaticsSelectIcon } from '../assets/statics_select.svg'
import { ReactComponent as EntityIcon } from '../assets/entities.svg'
import { ReactComponent as EntitySelectIcon } from '../assets/entities_select.svg'
import { ReactComponent as ReportsIcon } from '../assets/reports.svg'
import { ReactComponent as ReportsSelectIcon } from '../assets/reports_select.svg'
import Statics from '../pages/Statics/Statics'
import TradeBlotter from '../pages/TradeBlotter/TradeBlotter'
import Entity from '../pages/Entities/Entities'
import Reports from '../pages/Reports/Reports'

const router = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: <BlotterIcon />,
    selectIcon: <BlotterSelectIcon />,
    element: <TradeBlotter />
  },
  {
    name: 'Statics',
    path: '/statics',
    icon: <StaticsIcon />,
    selectIcon: <StaticsSelectIcon />,
    element: <Statics />
  },
  {
    name: 'Entity',
    path: '/entities',
    icon: <EntityIcon />,
    selectIcon: <EntitySelectIcon />,
    element: <Entity />
  },
  {
    name: 'Reports',
    path: '/reports',
    icon: <ReportsIcon />,
    selectIcon: <ReportsSelectIcon />,
    element: <Reports />
  }
]

export default router
